module.exports = __webpack_public_path__ + "static/media/brands-gc.8816a540.png";